/* PDP trust badge modal - mobile only

   Open deliberately does not .focus() the close button: focusing an element
   mid-transition makes a mobile browser scroll to keep it in view while the
   opening tap is still resolving into a click. The overlay, which never calls
   focus, always closed reliably; the close button, which did, did not. */

(function () {
  'use strict';

  var MOBILE = '(max-width: 1023px)';
  var ITEM = '.product-information .yg-trust__item';

  var mobile = window.matchMedia(MOBILE);
  var bound = new WeakSet();
  var observer = new MutationObserver(schedule);
  var scheduled = false;
  var openModal = null;
  var openTrigger = null;

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      init();
    });
  }

  function init() {
    var items = document.querySelectorAll(ITEM);

    for (var i = 0; i < items.length; i++) {
      var item = items[i];

      /* sections re-render in the theme editor - bind whatever replaces the item */
      if (item.parentElement) observer.observe(item.parentElement, { childList: true });

      if (bound.has(item)) continue;

      var trigger = item.querySelector('.yg-trust__trigger');
      var modal = item.querySelector('.yg-trust__modal');
      if (!trigger || !modal) continue;

      bound.add(item);
      trigger.addEventListener('click', handleTriggerClick(trigger, modal));
    }
  }

  /**
   * @param {HTMLElement} trigger
   * @param {HTMLElement} modal
   */
  function handleTriggerClick(trigger, modal) {
    return function () {
      if (!mobile.matches) return;
      open(modal, trigger);
    };
  }

  /**
   * @param {HTMLElement} modal
   * @param {HTMLElement} trigger
   */
  function open(modal, trigger) {
    if (openModal === modal) return;
    if (openModal) close();

    modal.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    openModal = modal;
    openTrigger = trigger;

    document.addEventListener('keydown', handleKeydown);
  }

  function close() {
    if (!openModal) return;

    openModal.classList.remove('is-open');
    document.removeEventListener('keydown', handleKeydown);

    if (openTrigger) {
      openTrigger.setAttribute('aria-expanded', 'false');
      openTrigger.focus();
    }

    openModal = null;
    openTrigger = null;
  }

  /**
   * @param {KeyboardEvent} event
   */
  function handleKeydown(event) {
    if (event.key === 'Escape') close();
  }

  document.addEventListener('click', function (event) {
    /* Element, not HTMLElement: a tap on the close icon's inline <svg> makes
       event.target an SVGElement, a sibling of HTMLElement under Element
       rather than a subtype, so an instanceof HTMLElement guard returned
       before .closest() (defined on Element.prototype) ever ran. */
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('[data-yg-trust-dismiss]')) close();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
